/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useContext, useEffect, useState } from 'react';
import './index.scss';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { fetchCouponData } from '../../services/Api/Coupon/CouponService';
import Image from '../common/Image.jsx';
import { Helmet } from 'react-helmet';
import {
  FLORENCE_HEALTH_CANONICAL,
  FLORENCE_HEALTH_DESC,
  FLORENCE_HEALTH_OG_DESC,
  FLORENCE_HEALTH_OG_TITLE,
  FLORENCE_HEALTH_PID,
  FLORENCE_HEALTH_PWD,
  FLORENCE_HEALTH_TITLE,
  RX_CARD_VIEW
} from '../../constants/defaults';
import RxCardSendCoupon from '../RxCard/RxCardSendCoupon';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { AuthContext } from '../../Contexts';

const FlorenceHealth = () => {
  const [cardImage, SetCardImage] = useState();
  const userData = useContext(AuthContext)?.userData;

  let userName = userData?.firstName;
  useEffect(() => {
    let intervalId = setInterval(() => {
      const fname = userData?.firstName;
      if (fname) {
        clearInterval(intervalId);
        fetchCardData();
      }
    }, 200);
    document.body.classList.add('florenceHealthBody');
  }, []);

  const fetchCardData = () => {
    try {
      let utmParams = _.getUTMParams();
      utmParams.createCard = true;
      fetchCouponData(
        FLORENCE_HEALTH_PID,
        FLORENCE_HEALTH_PWD,
        RX_CARD_VIEW,
        utmParams
      ).then(res => {
        SetCardImage(res.PDFUrl);
      });
    } catch (err) {
      console.log(err.message);
    }
  };

  return (
    <div className="florenceHealth homepage-new">
      <Helmet>
        <title>{FLORENCE_HEALTH_TITLE}</title>
        <meta name="description" content={FLORENCE_HEALTH_DESC} />
        <link rel="canonical" href={FLORENCE_HEALTH_CANONICAL} />
        <meta property="og:title" content={FLORENCE_HEALTH_OG_TITLE} />
        <meta property="og:description" content={FLORENCE_HEALTH_OG_DESC} />
        <meta property="og:url" content={FLORENCE_HEALTH_CANONICAL} />
        <meta property="og:site_name" content="SingleCare" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content={
            'https://www.singlecare.com/content/images/homepage/singleCareLogo.jpg'
          }
        />
      </Helmet>
      <div className="whiteHeader dd">
        <Link data-mp-text="Top-left Header logo" className="pointerNone">
          <img
            src="/content/images/header/singlecare-logo-grey.png"
            alt="singlecare-logo"
          />
        </Link>
      </div>
      <div className="florenceHealthBanner">
        <div className="florenceHealthBannerContent">
          <div className="ladyImg desktop-only">
            <LazyLoadImage
              src="/content/images/florenceHealth/lady.png"
              alt=""
            />
          </div>
          <div>
            <h1>
              SingleCare can save your patients <br className="desktop-only" />
              <span>up to 80%</span> on their prescriptions
            </h1>
            <p>
              All they need is to show a free SingleCare
              <br className="desktop-only" /> savings card at the pharmacy
            </p>
          </div>
        </div>
      </div>
      <div className="cardSection">
        <h2 className="textCenter">
          {' '}
          Get your free card and <br className="mobile-only" /> pass on the
          savings:{' '}
        </h2>
        <div className="card-masthead--image">
          <Image
            imageUrl={cardImage}
            imageAlt="contact"
            imageClass="contactImage"
            containerClass="imageContainer"
            loaderClass="loaderImage"
          />
          <RxCardSendCoupon
            selectedPrice={{
              PartnerUser: FLORENCE_HEALTH_PID,
              PartnerPassword: FLORENCE_HEALTH_PWD
            }}
            isRxCard={true}
            isFromDiscountPage={true}
            isFromPhysicalModal={false}
          />
        </div>
      </div>
      <div className="getCardProcessWrapper">
        <h2> How SingleCare Works </h2>
        <div className="cardsContainer">
          <div className="steps">
            <span>
              <LazyLoadImage
                src="/content/images/florenceHealth/search.png"
                alt=""
                width="85px"
              />
            </span>
            <div className="text-containt-wrapper">
              <p className="number">1</p>
              <div className="text">
                <h3 className="steps-title">
                  Look up discounted prescription prices
                </h3>
                <p>
                  Search for a drug to <br /> compare low prices at <br />{' '}
                  nearby pharmacies
                </p>
              </div>
            </div>
          </div>
          <div className="leftImageContainer">
            <LazyLoadImage
              src="/content/images/florenceHealth/path-top.png"
              alt=""
              className="mobile-only"
            />
            <LazyLoadImage
              src="/content/images/florenceHealth/path-desktop-left.png"
              alt=""
              className="desktop-only"
            />
          </div>
          <div className="steps step-2">
            <span>
              <LazyLoadImage
                src="/content/images/florenceHealth/card.png"
                alt=""
                width="90px"
              />
            </span>
            <div className="text-containt-wrapper">
              <p className="number">2</p>
              <div className="text">
                <h3 className="steps-title">Get a free coupon card</h3>
                <p>
                  The cards can be used <br /> right away, with no <br />{' '}
                  strings attached
                </p>
              </div>
            </div>
          </div>
          <div className="rightImageContainer">
            <LazyLoadImage
              src="/content/images/florenceHealth/path-desktop-right.png"
              alt=""
              className="desktop-only"
            />
            <LazyLoadImage
              src="/content/images/florenceHealth/path-bottom.png"
              alt=""
              className="mobile-only"
            />
          </div>
          <div className="steps">
            <span>
              <img
                src="/content/images/florenceHealth/price-tag.png"
                alt=""
                width="98"
              />
            </span>
            <div className="text-containt-wrapper">
              <p className="number">3</p>
              <div className="text">
                <h3 className="steps-title">Show the card to the pharmacist</h3>
                <p>
                  Savings are automatically <br /> applied at checkout
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {_.isEmpty(userName) && (
        <div className="memberBanner">
          <div className="memberBannerContent">
            <h2>
              Members save <br className="mobile-only" /> even more
            </h2>
            <p>
              Signing up is free and easy. Members get access to SingleCare’s
              lowest prices.
            </p>
            <Link className="button pink" to="/signup">
              Sign up
            </Link>
          </div>
        </div>
      )}
      <br className="hide" />
      <div className="faqContainer">
        <h2 className="textCenter">Frequently asked questions:</h2>
        <div className="faqQuestionAnswer">
          <div className="faqColumn">
            <p>
              <label className="float-left fullwidth">
                <strong> Q: </strong> Is SingleCare really free to use?
              </label>
              <span className="fullwidth">
                <strong> A: </strong>
                Yes, SingleCare is always totally free to use and <br /> free to
                join.
              </span>
            </p>
            <p>
              <label className="float-left fullwidth">
                <strong> Q: </strong>Can SingleCare be combined with <br />
                insurance or Medicare?
              </label>
              <span className="fullwidth">
                <strong> A: </strong> No, they cannot be combined. However, the{' '}
                <br />
                SingleCare prescription price may be lower than the <br />
                price with insurance or Medicare.
              </span>
            </p>
          </div>
          <div className="faqColumn">
            <p>
              <label className="float-left fullwidth">
                <strong> Q: </strong> Does SingleCare affect the prescription{' '}
                <br />
                process?
              </label>
              <span className="fullwidth">
                <strong> A: </strong> No! Medical professionals should prescribe{' '}
                <br />
                medication the way they normally would.
              </span>
            </p>
            <p>
              <label className="float-left fullwidth">
                <strong> Q: </strong> Is SingleCare health insurance?
              </label>
              <span className="fullwidth">
                <strong> A: </strong> No. SingleCare is a prescription discount
                plan, not a health <br />
                insurance plan. You can use your SingleCare card instead of{' '}
                <br />
                health insurance—not with your insurance. Since it’s separate{' '}
                <br />
                from health insurance, SingleCare savings cards can be used by{' '}
                <br />
                everyone, including people with and without insurance.
              </span>
            </p>
          </div>
          <div className="faqColumn">
            <p>
              <label className="float-left fullwidth">
                <strong> Q: </strong> How will my patients use SingleCare?
              </label>
              <span className="fullwidth">
                <strong> A: </strong> Anyone can use SingleCare if they have our
                free <br />
                discount card or our free app. Simply show the card to <br />
                the pharmacist when picking up a prescription.
              </span>
            </p>
            <p>
              <label className="float-left fullwidth">
                <strong> Q: </strong> Where can SingleCare be used?
              </label>
              <span className="fullwidth">
                <strong> A: </strong>SingleCare is accepted at more than 35,000
                pharmacies, <br />
                including at major brands such as CVS, Walgreens, Walmart,{' '}
                <br />
                Kroger, Albertsons, and their subsidiaries.
              </span>
            </p>
          </div>
        </div>
      </div>
      <div className="pharmaciesContainer">
        <h2>Use SingleCare at the following pharmacies: </h2>
        <div className="pharmacy-lists">
          <div className="pharmacy-items">
            <div className="pharmacy-logos">
              <LazyLoadImage
                alt="CVS Pharmacy"
                src="/content/images/pharmacy-images/logo-color-cvs.svg"
              />
            </div>
          </div>
          <div className="pharmacy-items">
            <div className="pharmacy-logos">
              <LazyLoadImage
                alt="Walmart"
                src="/content/images/pharmacy-images/logo-color-walmart.svg"
              />
            </div>
          </div>
          <div className="pharmacy-items">
            <div className="pharmacy-logos">
              <LazyLoadImage
                alt="Walgreens"
                src="/content/images/pharmacy-images/logo-color-walgreens.svg"
              />
            </div>
          </div>
          <div className="pharmacy-items">
            <div className="pharmacy-logos">
              <LazyLoadImage
                alt="Albertsons"
                src="/content/images/pharmacy-images/logo-color-albertsons.svg"
              />
            </div>
          </div>
          <div className="pharmacy-items">
            <div className="pharmacy-logos">
              <LazyLoadImage
                className="logoKroger"
                alt="Kroger"
                src="/content/images/pharmacy-images/logo-color-kroger.svg"
              />
            </div>
          </div>
          <div className="pharmacy-items">
            <div className="pharmacy-logos">
              <LazyLoadImage
                alt="heb"
                src="/content/images/pharmacy-images/logo-color-h-e-b.svg"
              />
            </div>
          </div>
          <div className="pharmacy-items">
            <div className="pharmacy-logos">
              <LazyLoadImage
                alt="hy-vee"
                src="/content/images/pharmacy-images/logo-color-hy-vee.svg"
              />
            </div>
          </div>
          <div className="pharmacy-items">
            <div className="pharmacy-logos">
              <LazyLoadImage
                alt="wegmans"
                src="/content/images/pharmacy-images/logo-color-wegmans.svg"
              />
            </div>
          </div>
        </div>

        <div className="moreLabel"> …and many more! </div>
      </div>
    </div>
  );
};

export default FlorenceHealth;
